import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory, SimpleHorizontalListAppearanceType, SimpleHorizontalListBgColorType, SimpleHorizontalListWidgetConfigData } from "common";
import { AccountBreakdown, AccountOnboarding } from "../../account/account.model";

@Injectable()
export class SalesDashboardAdapter {
	adaptAccountOnboardingListData = (data: AccountOnboarding): HorizontalListData[] => {
		return [
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Not started',
				displayedValue: data?.none?.toString(),
				valueTooltipMessage: 'Pushed to RYNO, no owner registered yet.',
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Owners registered',
				displayedValue: data?.registered?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Identity verified',
				displayedValue: data?.verified?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Agreement signed',
				displayedValue: data?.signed?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Renewal created',
				displayedValue: data?.renewalCreated?.toString(),
				isItemHidden: !data?.renewalCreated,
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Activated',
				displayedValue: data?.activated?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Total pushed to RYNO',
				displayedValue: data?.pushed?.toString(),
			}),
		]
	}

	adaptAccountBreakdownListData = (data: AccountBreakdown): HorizontalListData[] => {
		return [
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Pending',
				displayedValue: data?.pending?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Open',
				displayedValue: data?.open?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Closed',
				displayedValue: data?.closed?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Frozen',
				displayedValue: data?.frozen?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'In progress no payments',
				displayedValue: data?.inProgressNoPayments?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'In progress interest only payments',
				displayedValue: data?.inProgressInterestOnlyPayments?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Repayment',
				displayedValue: data?.repayment?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Renewal utilization too high',
				displayedValue: data?.renewalUtilizationTooHigh?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Pending renewal',
				displayedValue: data?.pendingRenewal?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Pending closure',
				displayedValue: data?.pendingClosure?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Declined',
				displayedValue: data?.declined?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Renewal declined',
				displayedValue: data?.renewalDeclined?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Renewed',
				displayedValue: data?.renewed?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Delinquent',
				displayedValue: data?.delinquent?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Payment relief',
				displayedValue: data?.paymentRelief?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Workout',
				displayedValue: data?.workout?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Write-off',
				displayedValue: data?.writeOff?.toString(),
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Paid-off',
				displayedValue: data?.paidOff?.toString(),
			}),
		]
	}
}
